import { useEffect, useState } from "react";
import { todayGossip } from "@/mocks/gossip";

const navItems = [
  { label: "今日瓜点", href: "#today" },
  { label: "最新爆料", href: "#hot" },
  { label: "热榜", href: "#trend" },
  { label: "栏目", href: "#category" },
  { label: "深度解读", href: "#deep" },
  { label: "关于我们", href: "#about" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const tickerTexts = todayGossip
    .slice(0, 5)
    .map((t) => `【${t.category}】${t.title}`)
    .join("   ");

  return (
    <header className="sticky top-0 z-50 w-full">
      {/* 顶部实时快讯条 */}
      <div className="w-full overflow-hidden bg-primary-600 text-background-50">
        <div className="mx-auto flex w-full max-w-[1320px] items-center px-4 md:px-6">
          <span className="relative z-10 flex shrink-0 cursor-default items-center gap-1.5 bg-primary-600 py-2 pr-3 text-xs font-medium tracking-wide whitespace-nowrap">
            <i className="ri-radar-line h-3.5 w-3.5 flex items-center justify-center text-accent-300" />
            实时快讯
          </span>
          <div className="relative flex-1 overflow-hidden border-l border-primary-500/60 py-2">
            <div className="animate-ticker flex w-max items-center whitespace-nowrap pl-4 text-xs text-primary-50/95">
              <span className="pr-1">{tickerTexts}</span>
              <span className="px-2 text-accent-300">•</span>
              <span className="pr-1">{tickerTexts}</span>
            </div>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div
        className={`w-full border-b transition-colors duration-300 ${
          scrolled
            ? "border-background-200 bg-background-50/95 backdrop-blur"
            : "border-background-200/60 bg-background-50"
        }`}
      >
        <div className="mx-auto flex w-full max-w-[1320px] items-center justify-between px-4 py-3 md:px-6">
          <a
            href="#top"
            className="flex items-center gap-2.5"
            aria-label="99吃瓜 首页"
          >
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-600 font-display text-lg font-bold text-background-50">
              99
            </span>
            <span className="font-display text-xl font-bold tracking-wide text-primary-700 md:text-2xl">
              吃瓜
            </span>
          </a>

          <nav className="hidden items-center gap-1 md:flex" aria-label="主导航">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                className="rounded-full px-4 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:bg-primary-50 hover:text-primary-700"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden items-center gap-2 md:flex">
            <button
              type="button"
              aria-label="搜索"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-background-200 text-foreground-700 transition-colors hover:border-primary-200 hover:text-primary-600"
            >
              <i className="ri-search-line h-5 w-5 flex items-center justify-center" />
            </button>
            <a
              href="#report"
              className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              <i className="ri-megaphone-line h-4 w-4 flex items-center justify-center" />
              我要爆料
            </a>
          </div>

          <button
            type="button"
            aria-label="打开菜单"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-200 text-foreground-800 md:hidden"
          >
            <i className={`ri-${open ? "close" : "menu"}-line h-5 w-5 flex items-center justify-center`} />
          </button>
        </div>

        {/* 移动端菜单 */}
        {open && (
          <div className="border-t border-background-200 bg-background-50 px-4 py-3 md:hidden">
            <nav className="flex flex-col gap-1" aria-label="移动端导航">
              {navItems.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-700"
                >
                  {item.label}
                </a>
              ))}
            </nav>
            <a
              href="#report"
              onClick={() => setOpen(false)}
              className="mt-3 flex items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-600 px-4 py-2.5 text-sm font-medium text-background-50"
            >
              <i className="ri-megaphone-line h-4 w-4 flex items-center justify-center" />
              我要爆料
            </a>
          </div>
        )}
      </div>
    </header>
  );
}